import ImageSearch from '../src/ImageSearch/index.tsx';
export default ImageSearch;
